<template>
  <div class="index-wrap">
    <div class="index-top-wrap">
      <SearchCard
        @radioChange="radioChange"
        @handleSearch="handleSearch"
        @handleClick="handleClick"
        @majorSearch="majorSearch"
        @patentHandleClick="patentHandleClick"
      ></SearchCard>
      <div class="index-top-item-wrap" v-if="newsTitle && newsTitle.length">
        <div class="index-switchTitle">
          <TitleCard
            :titles="newsTitle"
            :defaultSelected="defaultId"
            isSwitch
            :showMore="false"
            @switchTitle="switchTitleHandle"
          >
            <template>
              <NewList
                :resultList="newsList"
                @handleDetail="toDetails"
                :name="selectedName"
              ></NewList>
            </template>
          </TitleCard>
        </div>
      </div>
    </div>
    <div class="index-middle-wrap" v-if="analysisTitle && analysisTitle.length">
      <CarouselCard
        :analysisList="analysisList"
        :titles="analysisTitle"
        @handleDetail="toDetails"
        :defaultId="analysisId"
      ></CarouselCard>
    </div>
    <div class="index-middle-wrap" v-if="trainingTitle && trainingTitle.length">
      <InformationCard
        :name="queryName"
        :trainingList="trainingList"
        :titles="trainingTitle"
        @switchTitleInformation="switchTitleInformationHandle"
        @handleDetail="toDetails"
        :defaultId="trainingId"
      ></InformationCard>
    </div>
    <div class="index-footer-wrap">
      <FooterCard></FooterCard>
    </div>
  </div>
</template>

<script>
const ythPath = process.env.VUE_APP_BASE_YTH;
const Pat = process.env.VUE_APP_BASE_PAT; //一专利
import mixinsBackStack from "@/views/Back/mixins";
import commonDetail from "@/views/MIndex/mixin/index";
import NewList from "./components/NewsList";
import SearchCard from "./components/SearchCard/index.vue";
import CarouselCard from "./components/ServiceCard";
import InformationCard from "./components/InformationCard";
import FooterCard from "./components/FooterCard/index";
import { mapState, mapGetters } from "vuex";
import { getMenuList, getPatyeeToken } from "@/api/back.js";
import { getTenantId } from "@/api/databaseBin.js";
import { requestList } from "./configs/config";
import { is_cloneDeep } from "@/utils/cloneDeep.js";
import { getStorage } from "@/utils/index";
//import {encode} from '@/utils/base64.js'
export default {
  mixins: [mixinsBackStack, commonDetail],
  data() {
    return {
      defaultSelectedId: null, // 默认的选中id
      newsList: {}, //新闻模块数据
      newsTitle: [],
      analysisList: {}, //分析报告模块数据
      analysisTitle: [],
      trainingList: {}, //培训报告模块数据
      trainingTitle: [],
      selectedName: "新闻速递",
      queryName: "素养教育",
      requestList: [],
      defaultId: null,
      radioValue: 1, // 1全国，2国内，3全球
      analysisId: null,
      trainingId: null,
      List: [],
    };
  },
  components: {
    NewList,
    SearchCard,
    CarouselCard,
    InformationCard,
    FooterCard,
  },
  computed: {
    ...mapGetters("headerMenu", ["setUpdateMenuList"]),
    ...mapState({
      token: (state) => state.user.token,
    }),
    menuList() {
      return this.setUpdateMenuList;
    },
  },
  mounted() {
    this.initData();
  },
  watch: {
    //分配请求的数据到各自的数组中
    defaultSelectedId: {
      handler(val) {
        //遍历默认展示模块的请求
        this.requestList.forEach((item) => {
          if (item.id === val) {
            this.initModle(item);
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    async initData() {
      this.requestList = is_cloneDeep(requestList);
      //获取后台菜单显隐状态 给requestList赋值真实id
      const { data } = await getMenuList();
      data.forEach((item) => {
        this.requestList.forEach((ele) => {
          if (item.code === ele.code) {
            ele.id = item.id;
            if (item.status === "0") {
              ele.isShow = true;
            } else {
              ele.isShow = false;
            }
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((e) => {
              if (e.code === ele.code) {
                ele.id = e.id;
                if (e.status === "0") {
                  ele.isShow = true;
                } else {
                  ele.isShow = false;
                }
              }
            });
          }
        });
      });
      //遍历默认展示模块的请求
      this.requestList.forEach((item) => {
        if (item.default) {
          this.initModle(item);
        }
      });
      //遍历模块标题
      this.initTitle();
    },
    // recursion(list) {
    //   list.forEach((item) => {})
    // },
    initModle(item) {
      let params;
      if (
        ["trainingLectures", "competitionDynamics", "analysisReport"].includes(
          item.code
        )
      ) {
        params = {
          pageNum: item.pageNum,
          pageSize: item.pageSize,
          picture: "1",
          summary: "1",
        };
      } else {
        params = {
          pageNum: item.pageNum,
          pageSize: item.pageSize,
          //summary: '1'
        };
      }
      this.$store
        .dispatch("articleDetail/getHomeList", {
          ...params,
          code: item.code,
        })
        .then((res) => {
          item.list = this.handlerDateFormat(res.rows);
          console.log("item.prop", item);
          switch (item.prop) {
            case "newsList":
              this.newsList = item;
              break;
            case "analysisList":
              this.analysisList = item;
              break;
            case "trainingList":
              this.trainingList = item;
          }
        });
    },
    initTitle() {
      const obj = this.requestList.reduce((pre, cur) => {
        if (!Object.prototype.hasOwnProperty.call(pre, cur.prop)) {
          if (cur.isShow) {
            pre[cur.prop] = [
              {
                name: cur.label,
                id: cur.id,
                default: cur.default,
              },
            ];
          }
        } else {
          if (Object.prototype.hasOwnProperty.call(pre, cur.prop)) {
            if (cur.isShow) {
              pre[cur.prop].push({
                name: cur.label,
                id: cur.id,
                default: cur.default,
              });
            }
          }
        }
        return pre;
      }, {});
      this.newsTitle = obj.newsList;
      console.log("obj.newsList", obj.newsList);
      if (this.newsTitle) {
        this.defaultId = this.newsTitle[0].id;
      }
      this.analysisTitle = obj.analysisList;
      if (this.analysisTitle && this.analysisTitle.length) {
        this.analysisId = this.analysisTitle[0].id;
      }
      this.trainingTitle = obj.trainingList;
      if (this.trainingTitle && this.trainingTitle.length) {
        this.trainingId = this.trainingTitle[0].id;
      }
    },
    // 资讯类型切换
    switchTitleHandle({ id, name }) {
      this.defaultSelectedId = id;
      this.selectedName = name;
    },
    // 赛事切换
    switchTitleInformationHandle({ id, name }) {
      this.defaultSelectedId = id;
      this.queryName = name;
    },
    radioChange(value) {
      this.radioValue = value;
      console.log(value, typeof value);
    },
    async handleSearch(value) {
      this.handlerDealSearch(value);
      //window.open('https://www.patyee.com')
    },
    async majorSearch(v) {
      this.handlerDealSearch(v, true);
    },
    async handlerDealSearch(value, isMajor = false) {
      let searchValue =
        this.radioValue === 1
          ? `申请人(机构树)(精确)=(华南师范大学) and SS=(${value})`
          : `SS=(${value})`;
      // let page = isMajor ? "/search/advance" : "/search/result";
      // let source = this.radioValue === 3 ? "" : "cn";

      if (!this.token) {
        // this.$message.warning('请先登录')
        console.log("Pat", Pat);

        if (isMajor) {
          window.open(`https://patyee.com/search/advance`);
        } else {
          window.open(
            `https://ipisc.scnu.edu.cn/patyee/ipSearchResult?expre=${searchValue}`
          );
        }

        return;
      } else {
        window.open(
          `https://ipisc.scnu.edu.cn/patyee/ipSearchResult?expre=${searchValue}`
        );
      }
      // const { token, refreshToken } = await getPatyeeToken();

      // console.log(
      //   `${Pat}?token=${token}&refresh_token=${refreshToken}&redirect=${page}&source=${source}&expre=${searchValue}`
      // );

      // window.open(
      //   `${Pat}?token=${token}&refresh_token=${refreshToken}&redirect=${page}&source=${source}&expre=${searchValue}`
      // );
    },
    // 处理点击搜索卡片item项进行跳转
    async handleClick(val) {
      let tk;
      switch (val) {
        case 1:
          this.$router.push({
            path: "/informationService",
            query: { code: "xinxiServer" },
          });
          break;
        case 2:
          //window.open('https://ipisc.scnu.edu.cn/#/informationService/consult/detail?id=60&name=%E7%9B%B8%E5%85%B3%E5%92%A8%E8%AF%A2&selectedId=2154&code=relatedConsultation')
          //专利普查
          this.$router.push({
            path: "/informationService/consult/detail",
            query: {
              id: 60,
              name: "相关咨询",
              selectedId: 2154,
              code: "relatedConsultation",
            },
          });
          break;
        case 3:
          if (!this.token) {
            // window.open(`${ythPath}`);
            this.$message.warning("请先登录");
            return;
          }

          tk = await getTenantId();
          window.open(
            `${ythPath}?username=${getStorage(
              "userName",
              0
            )}&huashi=3&tenantId=${tk.id}`
          );
          break;
        case 4:
          this.$router.push({
            path: "/informationService",
            query: {
              code: "xinxiServer",
              selectedId: this.commonHandle("xinxiServer", "trainingLectures"),
            },
          });
          break;
        case 5:
          this.$router.push({
            path: "/resourceNavigation",
            query: {
              code: "zydh",
              selectedId: this.commonHandle("zydh", "abroadData"),
            },
          });
          break;
        default:
          break;
      }
    },
    async handlerOpenPatyee() {
      const { token, refreshToken } = await getPatyeeToken();
      if (!token && !refreshToken) {
        window.open(`https://patyee.com/`);
        return;
      }
      window.open(`${Pat}?token=${token}&refresh_token=${refreshToken}`);
    },
    patentHandleClick(val) {
      switch (val) {
        case 1:
          if (!this.token) {
            window.open("https://patyee.com/");
            // this.$message.warning("请先登录");
            return;
          }
          this.handlerOpenPatyee();
          //window.open('https://patyee.com/')
          break;
        case 2:
          window.open("https://app.innography.com/");
          break;
        case 3:
          window.open("http://www.innojoy.com/search/home.html");
          //window.open('http://www.innojoy.com/search/home.html')
          break;
        case 4:
          this.$message.warning("功能开发中，敬请期待");
          break;
        default:
          break;
      }
    },
    commonHandle(codeOne, codeTwo) {
      let obj = this.menuList.filter((res) => res.code === codeOne);
      let selectedId;
      obj[0].children.forEach((res) => {
        if (res.code === codeTwo) {
          selectedId = res.id;
        }
      });
      return selectedId;
    },
  },
};
</script>

<style lang="scss" scoped>
.index-footer-wrap {
  padding-top: 5px;
}
</style>
